var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,34.2h3V23.9h-3V34.2z M30.8,34.2h3v-21h-3V34.2z M22.5,34.2h3v-5.9h-3L22.5,34.2z M22.5,23.9h3v-3h-3L22.5,23.9z M9,42c-0.8,0-1.6-0.3-2.1-0.9C6.3,40.6,6,39.8,6,39V9c0-0.8,0.3-1.6,0.9-2.1C7.4,6.3,8.2,6,9,6h30c0.8,0,1.6,0.3,2.1,0.9C41.7,7.4,42,8.2,42,9v30c0,1.6-1.4,3-3,3H9z M9,39h30V9H9V39z M9,9L9,9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.de544b01b684ea0b442171e9e9e9104d.svg";
export { ForwardRef as ReactComponent };